// import {polyfill} from 'es6-promise';
import React from 'react';
import importedMessages from '../lang/messages';
import {notify} from "../primitives/Notification/Notification";
import HelperAjax from "../helpers/HelperAjax";
import {ContextDataStore} from "../helpers/HelperGlobalDataStore";
/**
 * CSS
 */
import '../scss/blueprint-css/_blueprint.scss';
import '../scss/base/base-dir.scss';

/**
 * Помощен клас (Value Object) за подаване на параметри и callback функции на ajaxCall метода
 */
export class AjaxParam {
	callbackSuccess = null;		// Callback фунцкция при успех.
	callbackError = null;		// Callback фунцкция при грешка.
	isLoading = true;			// Флаг, дали е в процес на извикване.
	messageSuccess = '';		// Съобщение за успешно приклюване.
	messageError = '';			// Съобщение за грешно приклюване.
	cypressParamString = '';
}

// polyfill();

/**
 * Базов React компонент. Всички компоненти го наследяват (контроли и pages).
 * Съдържа обща функционалност, която се използва от всички компоненти:
 *  - ajax заявки към сървъра.
 *  - глобална фунцция за raise-ване на event (Pub/Sub патерн)
 *  - масив с callback фунцкии за eventConsume (Pub/Sub патерн)
 */
class BaseComponent extends React.Component {

	componentName = '';
	componentToken = '';
	componentVisible = true;
	loading = false;
	mounted = false;


	/**
	 * Конструкторът. Bind-ва всички методи към обекта.
	 * Всеки компонент получава един задължителен параметър data. който се подава като
	 * props.
	 * Структирата на 'data' e JSON обект, със 'IComponentResponse' структура. Полетата са:
	 * - componentData
	 * - componentName
	 * - componentNewURL
	 * - componentErrors
	 * - componentSuccess
	 * - componentToken
	 * @param: props пропъртитата на компонента.
	 */
	constructor(props, context, name) {

		/**
		 * Важно извикване, не премахвай!
		 * */

		super(props, context);

		let data = null;

		if (name && context) {

			context.bindObj(name, this);

			data = context.get(name);
		}

		if (!data) {
			data = props.data;
		}

		/**
		 * Инициализация на state-a.
		 */
		this.state = {};

		if (data) {
			if (!name) {
				name = data.componentName;
			}
			this.componentName = name;
			this.componentToken = data.componentToken;
			this.state = data;
		}

		/**
		 * Флаг, дали в момента има изпълнение на ajax извикване.
		 */
		this.loading = props.isLazy;

		/**
		 * Private proprty. Дефинира се във всеки компонент. Съдържа съобщения за успех и грешки,
		 * които ще се показват в компонентите.
		 * @type Object
		 */
		this.messages = importedMessages[SHVO.pageLang];

		/**
		 *  BaseComponent.eventsPubSub:
		 *  Масив, дефиниран като статично пропърти на базовият клас.
		 *  Съдържа callback 'eventConsume' фунции, дефинирани евентуално в
		 *  някои компоненти от страницата. Ако някои компоненти имат дефинирани такива
		 *  фунцкии, те се извикват от eventRaise функцията.
		 *  Използва се като метод за комуникация между различните компоненти в страницата,
		 *  без да се предават callback фунцкии през props, а чрез publish/subscribe
		 *  механизъм.
		 */
		if (typeof this.eventConsume === "function") {
			this.eventConsume = this.eventConsume.bind(this);		// Binds this.
			BaseComponent.eventsPubSub.push(this.eventConsume);		// Запазва референция към фунцията.
		}

		/**
		 * Запазва референция към page-a (top level компонента)
		 * */
		if (!SHVO.pageComponent) {
			SHVO.pageComponent = this;
		}
	}

	setState(state, callback) {

		if (this.componentName) {
			this.context.set(this.componentName, state);
		}
		super.setState(state, callback);
	}

	/**
	 * Getter - връща internal state за даден компонент.
	 * Използва се, за да се вземе state-а на някой child компонент
	 * от неговият parent.
	 *
	 * @return Object;
	 */
	getComponentState = () => {
		return this.state;
	};

	/**
	 * Помощен метод за client side (JS) валидация на компонент.
	 * Връща true/false.
	 * @return boolean
	 */
	componentValidate = () => {
		return true;
	};

	/**
	 * Презареждане на компонента.
	 * Извиква default метода и презарежда с AJAX state-a само на текущият компонент.
	 * Този метод update-ва конкретният компонент изолирано, без да променя глобалният state обект.
	 * @param actionObject - данните, които се изпращат като параметри към serverside компонента.
	 * @param callback - callback функция, извиквана след презареждането.
	 * @param showLoading
	 */
	reload = (actionObject, callback = null, showLoading = true) => {

		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = (data) => {
			this.setState(data);

			/**
			 * Ако има callback функция, тя се извиква.
			 */
			if (typeof callback === "function") {
				callback(data);
			}
		};
		ajaxParam.isLoading = showLoading;
		ajaxParam.cypressParamString = '?actionReload' + this.componentName;
		this.ajaxCall('ActionGetDefaultState', actionObject, ajaxParam);
	};

	/**
	 * Raise-ва event.
	 * Чрез този метод даден компонент може да raise-не event. Ако друг компонент
	 * е имплементирал метода:
	 *        eventConsume(eventName, eventData)
	 * то тогава този метод ще бъде извикан.
	 * В статично property на базовият клас се пази масив с референции към всички
	 * имплементирани eventConsume фунции. Когато се raise-не event, всички фунцкии се
	 * извикват, като за параметър се подава името на event-a. Конкретната имплементация
	 * на consume функцията решава какво трябва да се изпълни в компонента.
	 * ---------------------
	 * Използва се като метод за комуникация между различните компоненти в страницата,
	 * без да се предават callback фунцкии през props, а чрез publish/subscribe
	 *  механизъм.
	 *
	 */
	eventRaise = (eventName, eventData) => {
		BaseComponent.eventsPubSub.forEach(function (func) {
			func(eventName, eventData);
		});
	};

	/**
	 * Метод от lifecycle-a на React компонента, където той може да зареди данните си с
	 * AJAX от сървъра самостоятелно. Всеки компонент може да получи данните си по два начина:
	 *  - да му се подадат (инжектират) от сървъра (компонента-родител).
	 *  - да си ги изтегли самостоятелно (s AJAX)
	 *
	 *  isLazy - флаг, подаван като props. Указва дали компонента да си зареди данните сам
	 *  (isLazy=1) с ajax или те ще бъдат подадени като масви (виж по-горе) от компонент-родител.
	 *
	 */
	componentDidMount() {

		if (!this.props.data) {
			return;
		}
		const {
			componentToken,
			componentName
		} = this.props.data;

		/**
		 * Private properties.
		 * Помощни методи, ползват се за идентификация на компонента при ajax заявките.
		 */
		if (componentToken) {
			this.componentToken = componentToken;
			this.componentName = componentName;
		}

		this.mounted = true;

		const {isLazy} = this.props;

		/**
		 * Ако компонента е lazyLoading компонент, данните му се зареждат чрез AJAX.
		 * Извиква се дефолтният метод 'ActionGetDefaultState'
		 */
		if (isLazy == '1') {
			let ajaxParam = new AjaxParam();
			ajaxParam.callbackSuccess = (data) => {
				if (SHVO.pageComponent.componentName === this.componentName) {
					SHVO.pageState = data;
				}

				if (data.componentToken) {
					this.componentToken = data.componentToken;
				}
				this.setState(data);

				this.eventRaise('LazyLoadingComplete', data);
			};
			ajaxParam.cypressParamString = '?LazyLoading-' + componentName;
			this.ajaxCall('ActionGetDefaultState', {}, ajaxParam);
		}
	}

	componentWillUnmount() {
		this.mounted = false;
		if (this.componentName) {
			this.context.bindObj(this.componentName, null);
		}
	}

	/**
	 * От React 16.4, 'componentWillReceiveProps' е deprecated.
	 * Вместо нея се използва 'getDerivedStateFromProps'.
	 * Тази функция се извиква винаги, когато се смени state-a или props-a.
	 * Това става както при Mounting-а на компонента, така и след зареждането на данните с AJAX при
	 * lazyLoading-a. Този метод се използва вместо componentWillReceiveProps.
	 * --------------
	 * https://reactjs.org/docs/react-component.html#mounting
	 * 'getDerivedStateFromProps' is invoked right before calling the render method,
	 * both on the initial mount and on subsequent updates.
	 * It should return an object to update the state, or null to update nothing.
	 *
	 *  -------------
	 *
	 *  Този метод е общ, както при зареждането на данни както през props, така и през ajax.
	 *  При lazy loading с AJAX, данните, с които работи компонента, още не са налични в констуктора.
	 *  Конструкторът се изпълнява един път, преди AJAX извикването и там е рано да се разичта,
	 *  че данните вече ще ги има налични чрез PROPS. Разполагането на инициализации в конструктора,
	 *  която да разчита на тези данни е ще доведе до грешки. Ако трябва да да се разполагат инициализации,
	 *  които да сработват независимо дали компонента е получил данните си през PROPS или през AJAX,
	 *  то тези проверки трябва да се слагат в ТОЗИ метод.
	 *  Така ще се гарантира, че те ще работят винаги, независимо как са заредени данните.
	 */
	static getDerivedStateFromProps(nextProps, prevState) {

		if (nextProps.data) {

			const {
				componentNewURL,
				componentInital,	// Флаг дали данните са от първоначалната инициализация. Ако са, не рендва нищо.
			} = nextProps.data;

			if (componentInital) {
				// Първочначлната инициализация на Page-a, ако се зарежда с Lazy Loadgin няма данни.
				// Не трябва да се рендва нищо.
				return null;
			}
			/**
			 * Ако е подадено URL, към което трябва да се пренасочи браузера, се прави redirect.
			 * */
			if ((componentNewURL !== '') && (componentNewURL !== undefined)) {
				window.location = componentNewURL;
				return null;
			}
		}

		return prevState;
	}

	/**
	 * Помощен метод за генериране на линк към друга страница.
	 * @param pageURL - името на страницата, която трябва да се зареди. Задължителен.
	 * @param actionId - ID-то на записа, което страницата трябва да обработи. Незадължително.
	 * @param useTabId - TabID-то на страницата в браузера (от sessionStorageID). Незадължително.
	 *
	 * Пример:
	 * this.getLink('hosting-page.php') генерира: /hosting-page.php
	 * this.getLink('hosting-page.php','3fhj5rs1') генерира: /hosting-page.php/a3fhj5rs1
	 */
	getLink = (pageURL, actionId = '', useTabId = false) => {
		if (actionId !== '') {
			actionId = '/a' + actionId;
		}
		let tabId = '';

		if (useTabId) {
			tabId = this.getPageTabId();

			if (tabId !== '') {
				tabId = '/t' + tabId;
			}
		}

		return '/' + pageURL + actionId + tabId;
	};

	// noinspection JSMethodCanBeStatic
	/**
	 * Генерира уникален идентификатор на страница в web browser-a.
	 * Освен сесията, за всеки отделен Tab се генерира tabId, с което се увеличава 'изолацията'
	 * на дадена страница не само в една сесия, но и в различни табове на браузера.
	 * Това позволява в повече табове да се работи с различен set от данни в една сесия за
	 * един URL адрес.
	 */
	getPageTabId = () => {
		if (typeof (sessionStorage) === 'object') {
			let key = 'BaseComponentTabId';
			let tabId = sessionStorage.getItem(key);
			if (tabId === null) {
				tabId = Math.random().toString(36).substr(2, 10);
				sessionStorage.setItem(key, tabId);

			}
			return tabId;
		}
	};

	/**
	 * @return BaseComponent
	 */
	rootPage = () => {
		return SHVO.pageComponent;
	}

	/**
	 * Основен AJAX метод, чрез който се извикват действия към сървъра или връщат данни.
	 * ВАЖНО: ВСИЧКИ AJAX заявки използват POST метод.
	 * За валидация и верификация се подават два допълнителни header-a:
	 *    x-token-dtsc
	 *    x-token-csfr
	 *
	 * Данните в REQUEST-a и REPONSE-a са JSON обекти.
	 * Request-a e описан във фунцията.
	 * Response-а е IComponentResponse обект.
	 * @param actionName - името на Action-a. Важно: Името на Action-a винаги трябва да започва с
	 * 'Action'. Името на Action-a трябва да съвпада с PHP метода в същият компонент, който ще
	 * обработи заявката.
	 * @param actionData - JSON обект, който се подава към сървъра.
	 * @param ajaxParam - обект от тип 'AjaxParam', които съдържа допълнителна информация за отговора
	 * на заявката и данните: callback функции при успех/грешка, флаг дали се изпълнява зареждането.
	 *
	 */
	ajaxCall = (actionName, actionData, ajaxParam = null) => {

		if (ajaxParam !== null) {
			let isValid = (typeof ajaxParam == "object") && ajaxParam.hasOwnProperty('isLoading');
			if (!isValid) {
				throw "ajaxParam must be an instance of 'AjaxParam'";
			}
		} else {
			ajaxParam = new AjaxParam();
		}

		let comName = this.componentName;
		let comCSFR = this.componentToken;
		let comPTId = this.getPageTabId();

		let callbackSuccess = ajaxParam.callbackSuccess;
		let callbackError = ajaxParam.callbackError;

		/**
		 * Timestamp valudation.
		 * Againg BruteForce.
		 * This is ONLY client generated field.
		 */
		let nowTS = (parseInt(Date.now() / 1000) + SHVO.pageTsDelta).toString(23);
		nowTS = Math.random().toString(8).substr(2, 10) + nowTS.split('').reverse().join('');

		this.loading = ajaxParam.isLoading;

		if (this.loading) {
			this.forceUpdate();
		}

		let body = {
			action_ptid: comPTId,
			action_name: actionName,
			action_data: actionData,
			component_name: comName,
			component_token_csfr: comCSFR,
			component_token_dtsc: nowTS,
			component_url: SHVO.pageURL,
			page_project: SHVO.pageProject,
		};

		let url = SHVO.pageAGW;
		if (window.cypressTest === true) {
			url = url + ajaxParam.cypressParamString;
		}

		HelperAjax.fetch('POST', url, JSON.stringify(body), {
			'x-token-dtsc': nowTS,
			'x-token-csfr': comCSFR,
			'x-http-referer': window.location.href,
			'Content-Type': 'application/json; charset=utf-8'
		}).then(response => {
			let code = response.respCode;		// http responce code (200, 301, 404);
			let data = response.respBody;		// JSON component data.

			if (code == '205') {
				location.reload(true);
				return;
			}

			/**
			 * Start. (Handle response).
			 */
			if (!data) {
				return;
			}
			try {
				data = JSON.parse(data);

				const {
					componentNewURL,
					componentErrors
				} = data;

				/**
				 * Обработка на пренасочванията, ако има - прави се тука, за да няма setState след това.
				 */
				if (componentNewURL) {
					this.navigate(componentNewURL);
					return;
				}
				this.loading = false;

				if (data.componentFlat) {
					this.context.init(data.componentFlat);
				}

				let hasErrors = ((typeof componentErrors === 'object') && (componentErrors.length > 0));

				/**
				 * Обработка на грешките, ако има.
				 */
				if (hasErrors) {
					if (typeof callbackError === "function") {
						callbackError(data);
						return;
					} else {
						const errorMessage = componentErrors[0];
						notify.error(this.messages[errorMessage] || errorMessage);
					}
				} else {
					/**
					 * Обработка на success резултата.
					 */
					if (typeof callbackSuccess === "function") {
						callbackSuccess(data);
						return;
					}
				}

				this.setState(data);

				/**
				 * END. (Handle response).
				 */
			} catch (error) {
				console.error(error);
			}

		}).catch(function (error) {
			console.error(error);
		});
	};

	/**
	 * Метод за пренасочване в друга страница.
	 * @param url - String от вида /web-page-hosting-order.php
	 */
	navigate = (url) => {
		if ((url !== '') && (url !== undefined)) {
			window.location = url;
		}
	};
}

/**
 *  Масив, дефиниран като статично пропърти на базовият клас.
 *  Съдържа callback 'eventConsume' фунции, дефинирани евентуално в
 *  някои компоненти от страницата. Ако някои компоненти имат дефинирани такива
 *  фунцкии, те се извикват от eventRaise функцията.
 *  Използва се като метод за комуникация между различните компоненти в страницата,
 *  без да се предават callback фунцкии през props, а чрез publish/subscribe
 *  механизъм.
 */

BaseComponent.contextType = ContextDataStore;
BaseComponent.eventsPubSub = BaseComponent.eventsPubSub || [];

export default BaseComponent;